import React, { Fragment } from 'react';
import ThreeDotMenu from 'src/ui/library/ThreeDotMenu';
import FilterBoxContainer from 'src/ui/features/Documents/containers/FilterBoxContainer';
import Table from 'src/ui/library/Table';
import intl from 'react-intl-universal';
import { createTableData } from 'src/helpers';
import moment from 'moment';
import TextInput from 'src/ui/library/TextInput';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import { DOC_UPLOAD_NEW_URL } from 'src/constants/constants.js';
import Button from 'src/ui/library/Button';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
import Dropdown from 'src/ui/library/Dropdown';
import MenuItem from '@material-ui/core/MenuItem';

const DocumentsTablePres = ({
  onDocumentsSearch,
  docsTableData,
  openDocument,
  setDocumentDelete,
  setDocumentDetails,
  isCorpClient,
  isApplicant,
  containerRef,
  totalRows,
  page,
  onTableChange,
  searchDocumentText,
  isEYPro,
  isCase,
  caseManagerId,
  resetPageToZero,
  isCasesDocument = false,
  ChangeUploadStatus,
  handleCheckboxSelect,
  handleCheckboxSelectforAcknowledge,
  clientId,
  history,
  isUSAdminwithDeleteRights,
  getExecSPAPI,
  isLoading,
  showDropDown,
  uploadStatusList,
}) => {
  if (!docsTableData.success) return false;

  const optionData = [
    {
      title: 'View Details',
      type: 'details',
    },
    {
      title: 'Open Document',
      type: 'open',
    },
    {
      title: 'Upload Documents',
      type: 'upload',
    },
    isCorpClient === false
      ? {
          title: 'Delete',
          type: 'delete',
        }
      : null,
  ];

  const renderToolTip = function(systemId, employeeNum, label1, label2) {
    return (
      <table>
        <tbody>
          <tr>
            <td className="tipLabel">{label1}</td>
            <td className="tipLabel">{label2}</td>
          </tr>
          <tr>
            <td className="tipText">{systemId}</td>
            <td className="tipText">{employeeNum}</td>
          </tr>
        </tbody>
      </table>
    );
  };

  let updateView = showDropDown ? 'uploadStatus' : 'markReceived';
  let { rows, columns } = createTableData('documents', {
    rows: docsTableData.caseDocuments,
    columns: docsTableData.columns,
    visible: isCasesDocument
      ? [
          updateView,
          'acknowledge',
          'documentId',
          'documentType',
          'documentName',
          'additionalComments',
          'sentToSureprep',
          'acceptedBySureprep',
          isCorpClient || isApplicant || (isCase && isEYPro) ? null : 'engagementName',
          isApplicant || (isCase && (isEYPro || isCorpClient)) ? null : 'applicantName',
          'linkages',
          'dateUploaded',
          'dateAcknowledged',
        ]
      : [
          'documentId',
          'documentType',
          'documentName',
          'additionalComments',
          isCorpClient || isApplicant || (isCase && isEYPro) ? null : 'engagementName',
          isApplicant || (isCase && (isEYPro || isCorpClient)) ? null : 'applicantName',
          'primaryContactEmailID',
          'casePhase',
          'detailedStatus',
          'linkages',
          'dateUploaded',
          'dateAcknowledged',
        ],
    options: {
      uploadStatus: {
        renderComponent: (value, tableMeta) => {
          let dropdownvalues = uploadStatusList.filter(item => item.id > 67 && item.id < 77);

          let selectedValue = parseInt(value) > 67 && parseInt(value) < 77 ? value : null;

          let selectLabel = selectedValue !== null ? null : parseInt(value) === 67 ? 'Uploaded' : 'Select Status';
          const { caseDocuments } = docsTableData;
          const { origRowIndex } = tableMeta;
          return (
            <div id="uploadListDropdownContainer">
              {uploadStatusList && (
                <Dropdown
                  id="uploadListDropdown"
                  name="uploadListDropdown"
                  disabled={parseInt(value) === 67 ? true : false}
                  label={selectLabel}
                  value={selectedValue}
                  onChange={event => ChangeUploadStatus(event.target.value, origRowIndex, caseDocuments)}
                  className={'Documentdropdown'}
                  disableUnderline={true}>
                  {dropdownvalues &&
                    dropdownvalues.map(item => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.message}
                      </MenuItem>
                    ))}
                </Dropdown>
              )}
            </div>
          );
        },
      },
      markReceived: {
        renderComponent: (value, tableMeta) => {
          const { caseDocuments } = docsTableData;
          const { origRowIndex } = tableMeta;
          let documentId = caseDocuments && caseDocuments[origRowIndex].documentId;
          return (
            <div>
              <input
                checked={value === 'true' ? true : false}
                disabled={value === 'true' && documentId !== '0' ? true : false}
                type="checkbox"
                id="markReceived"
                name={'somename'}
                value="markReceived"
                onChange={handleCheckboxSelect.bind(value, origRowIndex, caseDocuments)}
              />
            </div>
          );
        },
      },
      acknowledge: {
        renderComponent: (value, tableMeta) => {
          const { caseDocuments } = docsTableData;
          const { origRowIndex } = tableMeta;
          let documentId = caseDocuments && caseDocuments[origRowIndex].documentId === 0 ? true : false;
          return (
            <div>
              <input
                checked={value === 'true' ? true : false}
                disabled={documentId || value === 'true' ? true : false}
                type="checkbox"
                id="acknowledge"
                name={'somename'}
                value="acknowledge"
                onChange={handleCheckboxSelectforAcknowledge.bind(value, caseDocuments, origRowIndex)}
              />
            </div>
          );
        },
      },
      documentId: {
        renderComponent: value => (value && value !== '0' ? value : ''),
      },
      engagementName: {
        sortable: true,
        renderComponent: value => <div>{value}</div>,
      },
      applicantName: {
        sortable: false,
        renderComponent: value => <div>{value}</div>,
      },
      dateUploaded: {
        renderComponent: value => {
          let date = new Date(value);
          let year = date.getFullYear();
          return year === 1 || year === '1' ? '' : moment(new Date(value)).format('DD-MMM-YYYY');
        },
      },
      dateAcknowledged: {
        renderComponent: value => {
          let date = new Date(value);
          let year = date.getFullYear();
          return year === 1 || year === '1' ? '' : moment(new Date(value)).format('DD-MMM-YYYY');
        },
      },
      documentName: {
        renderComponent: value => <div className="document-name-link">{value}</div>,
      },
      primaryContactEmailID: {
        renderComponent: value => <div>{value}</div>,
      },
      casePhase: {
        renderComponent: value => <div>{value}</div>,
      },
      detailedStatus: {
        renderComponent: value => <div className="document-name-link">{value}</div>,
      },
      additionalComments: {
        renderComponent: value => <div>{value ? 'Yes' : 'No'}</div>,
      },
      sentToSureprep: {
        sortable: false,
        renderComponent: value =>
          value && value.toUpperCase() === 'YES'
            ? (value = 'Y')
            : value && value.toUpperCase() === 'NO'
            ? (value = 'N')
            : value && value.toUpperCase() === 'NA'
            ? (value = 'NA')
            : value,
      },
      acceptedBySureprep: {
        sortable: false,
        renderComponent: value =>
          value && value.toUpperCase() === 'YES'
            ? (value = 'Y')
            : value && value.toUpperCase() === 'NO'
            ? (value = 'N')
            : value && value.toUpperCase() === 'NA'
            ? (value = 'NA')
            : value,
      },
    },
  });

  if (!isApplicant) {
    columns.push({
      id: 'Actions',
      displayText: 'Actions',
      stickyRight: true,
      renderComponent: (value, tableMeta) => {
        return (
          <ThreeDotMenu
            options={optionData}
            handleMenuSelect={handleMenuSelect}
            tableValue={value}
            tableMeta={tableMeta}
            tableData={docsTableData}
          />
        );
      },
      sortable: false,
    });
  }

  const handleMenuSelect = (type, tableMeta) => {
    const { caseDocuments, messages } = docsTableData;
    const { origRowIndex } = tableMeta;

    if (type === 'delete') {
      // open dialog, call delete document on yes.
      /**
       * re-render table required because the rowIndex is shifted on delete, so subsequent deletes do not work.
       */
      setDocumentDelete(docsTableData, tableMeta);
    } else if (type === 'open') {
      let documentId = caseDocuments ? caseDocuments[origRowIndex].documentId : messages[origRowIndex].documentId;
      if (documentId !== 0) {
        openDocument(documentId);
      }
    } else if (type === 'details') {
      setDocumentDetails(
        origRowIndex,
        caseManagerId,
        caseDocuments[origRowIndex].documentGroupId,
        caseDocuments[origRowIndex].documentTypeId,
        caseDocuments[origRowIndex].caseDocumentTypeId,
      );
    } else if (
      type === 'upload' &&
      caseDocuments[origRowIndex].documentType !== 'Chat History' &&
      caseDocuments[origRowIndex].documentType !== 'All Documents ZIP'
    ) {
      const params = `${caseManagerId}/${clientId}/${caseDocuments[origRowIndex].documentGroupId}/${caseDocuments[origRowIndex].documentTypeId}/${caseDocuments[origRowIndex].caseDocumentTypeId}`;
      history.push(`${DOC_UPLOAD_NEW_URL}/${caseManagerId ? params : ''}`);
    }
  };

  return (
    <Fragment>
      <div className="cases-table-container" ref={containerRef}>
        {isLoading && <ServiceSpinner classname="ssi-spinner-mini" />}
        <div className="cases-autocomplete-container">
          <TextInput
            label={
              isApplicant
                ? `${intl.get('documents.applicantSearch')}`
                : isCase
                ? `${intl.get('documents.searchDetails')}`
                : `${intl.get('documents.search')}`
            }
            value={searchDocumentText}
            onChange={event => onDocumentsSearch(event)}
            id="searchDocumentText"
            styleType="documentLandingSearch"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" className={'document-search-searchicon'}>
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <FilterBoxContainer
            className="filter-icon"
            containerRef={containerRef}
            isCorpClient={isCorpClient}
            isApplicant={isApplicant}
            isCase={isCase}
            caseManagerId={caseManagerId}
          />
        </div>
        <Table
          styleType={'landingPage'}
          serverSide={true}
          columns={columns}
          rows={rows}
          resetPageToZero={resetPageToZero}
          page={page}
          totalRows={totalRows}
          onTableChange={onTableChange}
          isCasesDocument={isCasesDocument}
          showDropDown={showDropDown}
          rowsPerPage={150}
        />
        {!isCase && isUSAdminwithDeleteRights && (
          <div>
            <Button styleType="cmsUpload" onClick={() => getExecSPAPI()}>
              <span>{intl.get('documents.documentUpload.executespapi')}</span>
            </Button>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default DocumentsTablePres;



// WEBPACK FOOTER //
// ./src/ui/features/Documents/presentational/DocumentsTablePres.js